// import DynamicScroll from "../Components/DynamicScroll";
import Hero from "../Components/hero";
import InfoHomescreen from "../Components/InfoHomescreen";
import Gallery from "../Components/Gallery";

const HomeScreen = () => {

    return (
        <div className="m-0 p-0">
            <Hero/>
            <InfoHomescreen/>
            <Gallery/>
            {/* <DynamicScroll/> */}
        </div>
    );
};
export default HomeScreen;